// extracted by mini-css-extract-plugin
module.exports = {"list":"DesktopDropdown_list__lbvm1"};